import {ERROR} from './api';

import type {HandleError} from '@pb/middleware-api';

export const handleErrors: HandleError = params => {
    const {responseData, response} = params;
    const ok = response?.ok;
    const status = response?.status;

    if (!ok) {
        const error = responseData || ERROR;

        if (status === 500) {
            return Promise.reject(ERROR);
        }

        return Promise.reject(error);
    }

    return Promise.resolve(responseData);
};
